import type { Struct } from 'superstruct';
import { coerce, literal, nullable } from 'superstruct';

/**
 * This should be wrapped around any type that is used
 * to type an array.
 *
 * Allows null/undefined values for the type.
 *
 * This is necessary because `microdiff` will return
 * null/undefined array items if there is no diff across
 * that index in the array.
 */
export const historyArrayItem = <T, S>(struct: Struct<T, S>) =>
	coerce(nullable(struct), literal(undefined), () => null);
